export default __webpack_public_path__ + "static/media/ClinicianGuide.0727843a.pdf";